<template lang="pug">
.inline-block.border-2.border-gray-400.relative.text-base.text-gray.font-normal.text-left.inline-block.rounded.px-8.leading-10.overflow-hidden
  select.bg-transparent.appearance-none.py-select.w-40(v-model="order")
    option(v-for="(sortOption, index) in sortOptions" :key="index" :value="sortOption.value") {{ sortOption.label }}
  span.fal.fa-chevron-down.text-lg.text-primary.font-medium.transform(class="translate-y-select")
</template>

<script>
export default {
  props: {
    searchParams: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      order: null,
      sortOptions: [
        {
          label: 'Nouveauté',
          value: 'sort_by_created_at desc'
        },
        {
          label: 'Prix croissant',
          value: 'sort_by_price asc'
        },
        {
          label: 'Prix décroissant',
          value: 'sort_by_price desc'
        },
        {
          label: 'Surface croissante',
          value: 'sort_by_surface asc'
        },
        {
          label: 'Surface décroissante',
          value: 'sort_by_surface desc'
        }
      ]
    }
  },

  watch: {
    order () {
      if (this.$store.getters.getParams.sort !== this.order) {
        this.$store.commit('updateParams', { key: 'sort', value: this.order })

        this.$store.dispatch('searchAccommodations')
      }
    }
  },

  mounted () {
    this.order = this.searchParams.sort

    this.$nextTick(() => {
      this.$store.commit('updateReady', 'selectOrder')
    })
  }
}
</script>
